import { getMinorUnitMultiplier } from '@shared/utils/currency/minorUnits';

/**
 * Drops the cents from a fund balance, so it reads like the whole-unit prices on the hotel tiles.
 *
 * Rounds DOWN, unlike `translatedPrice`, which rounds prices UP. Up is safe for a price — you quote
 * more than you charge. A balance rounded up promises money the couple does not have.
 *
 * Never floors real money to nothing: a balance under one whole unit keeps its cents, because
 * "$0" reads as an empty fund and would put "Book a stay with your $0" on a CTA.
 *
 * Display only. Never feed the result to checkout, which spends exact minor units.
 */
export const floorFundBalanceToWholeUnits = (minorUnits: number, currencyCode: string): number => {
  const multiplier = getMinorUnitMultiplier(currencyCode);
  const floored = Math.floor(minorUnits / multiplier) * multiplier;
  return floored === 0 ? minorUnits : floored;
};
